/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { isEmpty } from '../helper/is-empty.helper';
import { getValidationContextValue } from '../helper/validate.helper';
import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';

export interface ComparatorValidationOptions {
  comparator?: (a: any, b: any) => boolean;
  key?: string;
  value?: any;
}

export function validateComparator(
  value: any, options: ComparatorValidationOptions, context: object
): boolean {
  if (isEmpty(value)) {
    return true;
  }
  if (!options) {
    throw new ApplicationError({
      key: CoreErrorKey.VALIDATION_OPTIONS_MISSING,
      message: 'Validation options missing'
    });
  }
  const comparator = options.comparator || ((a: any, b: any) => a === b);
  if (options.key !== undefined) {
    return comparator(value, getValidationContextValue(context, options.key));
  }
  if (options.value !== undefined) {
    return comparator(value, options.value);
  }
  throw new ApplicationError({
    key: CoreErrorKey.VALIDATION_OPTIONS_INVALID,
    arguments: { options },
    message: 'Validation options invalid'
  });
}
